export default __webpack_public_path__ + "static/media/OpenSans-MediumItalic.7d2b40c4.ttf";